type FAQIconProps = {
  color: string;
};

export const FAQIcon = ({ color }: FAQIconProps) => (
  <svg width="60px" height="60px" viewBox="0 0 60 60">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <circle
        id="Oval"
        stroke={color}
        strokeWidth="2"
        cx="30"
        cy="30"
        r="22"
      ></circle>
      <g id="Group-2" transform="translate(24.25, 18)">
        <g id="Clip-1"></g>
        <text
          id="?"
          mask="url(#mask-2)"
          fontFamily="OpenSans, Open Sans"
          fontSize="30"
          fontWeight="normal"
          fill={color}
        >
          <tspan x="0" y="23">
            ?
          </tspan>
        </text>
      </g>
    </g>
  </svg>
);
